import type { SearchState } from '../constants/search';

export const getFetchFromCursor: (state: SearchState) => string = (state: SearchState): string => {
	return state.paginationTokens[0]?.cursor;
};

export const getSelectedProduct: (state: Pick<SearchState, 'selectedProducts'>) => string = (
	state: Pick<SearchState, 'selectedProducts'>,
): string => state.selectedProducts[0];

export const getProducts: ({
	selectedProducts,
	availableProducts,
}: Pick<SearchState, 'selectedProducts' | 'availableProducts'>) => {
	selectedProduct: string;
	filteredProducts: string[];
	availableProducts: string[];
} = ({
	selectedProducts,
	availableProducts,
}: Pick<SearchState, 'selectedProducts' | 'availableProducts'>) => {
	const selectedProduct = selectedProducts?.[0];
	const filteredProducts = selectedProduct ? [selectedProduct] : availableProducts;
	return {
		selectedProduct,
		filteredProducts,
		availableProducts,
	};
};
